import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserSessionService } from '../../../app-user-session.service';
import { ModalService, ToastService } from '../../../blocks';
import { inTransferBodies, OperationPlaceSettingsService } from '../operation-place-settings.service';

@Component({
  selector: 'app-new-coming-from',
  templateUrl: './new-coming-from.component.html',
  styleUrls: ['./new-coming-from.component.css']
})
export class NewComingFromComponent implements OnInit {
  inTransferBodiesList: inTransferBodies[] = [];
  object: any = <any>{};
  serial: number;
  updateComingFrom: number;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private _ModalService: ModalService,
    public translate: TranslateService,
    private _toastService: ToastService,
    private _userSessionService: UserSessionService,
    private _operationPlaceSetting: OperationPlaceSettingsService
  ) { }

  ngOnInit() {
  }
  updateComingForm() {
    this.serial = this._userSessionService.getSessionKey('updateComingFrom')
    this.object.serial =  this.serial ,
    this.object.updateComingFrom = this.updateComingFrom
    if (this.serial&&this.updateComingFrom) {
      this._ModalService.activeTranslatedMesg(this.translate.currentLang == 'ar' ? 'سيتم حذف جهة التحويل القديمة واستبدالها جهة التحويل الحالية' : 'The old Old  Coming From will be deleted and replaced with the current Coming From').then(responseOK => {
        if (responseOK) {
          this._operationPlaceSetting.updateComingFrom(this.object).pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              data => {
              },
              error => console.log(error),
              () => {
                null
              });
        }
      });
    }
     else {
      this._toastService.activateMsg(this.translate.currentLang == 'ar' ? 'برجاء ادخال رقم صحيح او تغيير الوحده' : 'please insert a correct number or change the unit')
  
  return;
    }
  }

}
